import $ from 'jquery';
import 'jquery-mask-plugin';

$('.format-phone').mask('(999) 999-9999');

// Also create char counter

var enteredMessage = document.getElementById('message');
var charCounter = document.getElementById('char-counter');

//validation variables
var phoneInput = document.getElementById('phone_number');
var phoneInputError = document.getElementById('phone-error');

const countChar = () => {
  let numEntered = enteredMessage.value.length;
  charCounter.textContent = numEntered + '/150';
};

enteredMessage.addEventListener('input', countChar);

//input validation
const phonePattern = /^\x28\d{3}\x29 \d{3}-\d{4}$/;

phoneInput.onblur = function() {
  if (phoneInput.value.match(phonePattern) == null) {
    phoneInputError.style.display = 'block';
    phoneInput.style.marginBottom = '8px';
    phoneInput.style.border = '1px solid red';
  } else {
    phoneInput.style.border = '1px solid #eaeaea';
    phoneInput.style.marginBottom = '16px';
    phoneInputError.style.display = 'none';
  }
};
